import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import i18n from "../../../../i18nSetup";
import Tooltip from "@mui/material/Tooltip";


import ModeIcon from '../../icons/mode-icon'
import {connect} from "react-redux";
import {rewriteHeadsign} from '../../../actions/ui'

class ItinerarySummary extends Component {
  static propTypes = {
    itinerary: PropTypes.object
  }

  render () {
    const { itinerary, direction } = this.props

    const blocks = []
    itinerary.legs.forEach((leg, i) => {
      // Skip mid-itinerary walk transfer legs
      if (
        i > 0 &&
        i < itinerary.legs.length - 1 &&
        !leg.transitLeg &&
        itinerary.legs[i - 1].transitLeg &&
        itinerary.legs[i + 1].transitLeg) {
        return null
      }

      let durationMinutes = parseInt(leg.duration/60)
      if(0 === durationMinutes && 'WALK' === leg.mode && itinerary.legs.length > 1){
        //short walk, doesn't worth mentioning
        if (i === itinerary.legs.length - 1) {
            blocks.pop() // pop the last chevron, not needed
        }
          return null;
      }

      // Add the mode icon
      blocks.push(
        <div key={blocks.length} style={{display:'flex',alignItems:'center',padding:0,margin:0}}>
          <ModeIcon mode={leg.mode} agencyName={leg.agencyName} />
        </div>
      )

      // If a transit leg, add the name (preferably short; long if needed)
      if (leg.transitLeg) {
          if(leg.shortNames && leg.shortNames.length && leg.shortNames[0]){

          //{!index ? ( : null}
          let routeBlocks = [];
          routeBlocks.push(<div key='routesBefore' style={{backgroundColor:'white',position:'absolute',zIndex:800,height:25,width:9,left:-3}} />)
          routeBlocks.push(<div key='routesAfter' style={{backgroundColor:'white',position:'absolute',zIndex:800,height:25,width:9,right:-3}} />)
          leg.shortNames.forEach((shortName,index) => {
            let extraStyle = {};
            if(leg.mode == 'RAIL'){
              if(index){
                return null;
              }else{
                extraStyle.paddingInlineEnd = 6;
              }
            }
        
            if(!index) extraStyle.paddingInlineStart =  6;
            if(index === leg.shortNames.length-1) extraStyle.paddingInlineEnd = 6;
            routeBlocks.push(
              <Tooltip key={'route' + index} title={`${index == 0 ? i18n.t('waitFor') : i18n.t('orRoute')} ` + (shortName || rewriteHeadsign(leg.headsigns[i]))}>
                <div  className={'route-color-wrap skew'} style={{
                  backgroundColor: '#' + (leg.routeColors[index] || '000'),
                }}>


                  <div className='route-short-name unskew' style={extraStyle}>
                    {
                      `${shortName || rewriteHeadsign(leg.headsigns[i])}`
                    }
                  </div>
                </div>
              </Tooltip>
            )

          })

          blocks.push(<div key={'routes' + blocks.length} style={{position:'relative',display:'inline-block',whiteSpace:'nowrap'}}>{routeBlocks}</div>);

        }else{

        

        blocks.push(
          <div key={blocks.length} className='summary-block name-block' style={{display:'inline-block',whiteSpace:'nowrap',backgroundColor: '#'+leg.routeColor,minHeight:24,alignItems:'center',alignContent:'center',justifyContent:'center',alignSelf:'center'
          }}>
            <span className='route-short-name' style={{justifyContent:'center'}}>
              {leg.routeShortName || leg.routeLongName}
            </span>
          </div>
        )

          }
      }else {
        
        blocks.push(<span key={blocks.length} style={{
          fontSize: 12, display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end'
        }}>{`${durationMinutes}  ${i18n.t('min')}`}</span>)
      }

      // If not the last leg, add a '►'
      if (i < itinerary.legs.length - 1) {
        blocks.push(
          <div key={blocks.length} className='summary-block arrow-block'>{direction === 'ltr'?<ArrowRightIcon />: <ArrowLeftIcon />}</div>
        )
      }
    })

    return <div className='summary'>{blocks}</div>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    direction: state.otp.config.dir
  }
}
export default connect(mapStateToProps) (ItinerarySummary)